import { useSelector } from "react-redux";
import { apiSlice } from "../../../../app/service/Service";
import { createSlice } from "@reduxjs/toolkit";
const userId = localStorage.getItem("userId")
// const roundCount = localStorage.getItem("roundCount")
// console.log("roundCountroundCount",roundCount)
export const useSaveCardsSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        savePlayersCard: builder.mutation({
            query: (body) => ({
                url: `GameScore/SavePlayersCard`,
                method: "POST",
                body,
            })
        }),

        savePlayersCardForP2P: builder.mutation({
            query: (body) => ({
                url: `GameScore/SavePlayerCardForP2P`,
                method: "POST",
                body,
            })
        }),
        showPlayersCard: builder.mutation({
            query: (roomId) => ({
                url: `GameScore/ShowPlayersCard?roomId=${roomId}`,
                method: "POST",
            })
        }),

        showPlayersCardForp2p: builder.mutation({
            query: ({ rId, round }) => ({
                url: `GameScore/ShowPlayersCardForP2P?roomId=${rId}&userId=${userId}&roundCount=${round}`,
                method: "POST",
            })
        }),
        updatePlayersCard: builder.mutation({
            query: (body) => ({
                url: `GameScore/UpdatePlayersCard`,
                method: "POST",
                body
            })
        }),

        updatePlayersCardP2P: builder.mutation({
            query: (body) => ({
                url: `GameScore/UpdatePlayersCardforP2P`,
                method: "POST",
                body
            })
        }),
        rejoinGameGin: builder.query({
            query: () => ({
                url: `GameScore/CheckPlayerToRejoinGameGin?UserId=9eb5f558-af6c-40a4-930a-9ff15547f599`,
                method: "GET",
            })
        }),
    })
})

export const { useSavePlayersCardMutation, useShowPlayersCardMutation, useUpdatePlayersCardMutation,
    useShowPlayersCardForp2pMutation, useSavePlayersCardForP2PMutation, useUpdatePlayersCardP2PMutation,
    useRejoinGameGinQuery } = apiSlice;


const initialState = { list: [], newGame: true, isGameScore: [] }
const PlayerToPlayerSaveCardSlice = createSlice({
    name: "playerCardDetail",
    initialState,
    reducers: {
        saveFirstPlayerCard: (state, action) => {
            state.list = action.payload
            console.log("listssss", action.payload)
        },
        isNewGame: (state, action) => {
            console.log("listssss1", action.payload)
            state.newGame = action.payload
        },
        saveScore: (state, action) => {
            console.log("listssss2",action.payload)
            state.isGameScore = action.payload
        }
    },
})

export const { saveFirstPlayerCard, isNewGame , saveScore} = PlayerToPlayerSaveCardSlice.actions

// export const selectlistData = (state) => state


export default PlayerToPlayerSaveCardSlice.reducer
